export const firstAndLastNameValidator =
	/^[a-zA-ZĄąĆćĘęŁłŃńÓóŚśŹźŻż]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g;
